import { render, staticRenderFns } from "./TasnateaList.vue?vue&type=template&id=88531816&scoped=true"
import script from "./TasnateaList.vue?vue&type=script&lang=js"
export * from "./TasnateaList.vue?vue&type=script&lang=js"
import style0 from "./TasnateaList.vue?vue&type=style&index=0&id=88531816&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88531816",
  null
  
)

export default component.exports